import o, { css as t } from "styled-components";
const r = o.div.withConfig({
  displayName: "HelperBody",
  componentId: "sc-8qnsok-0"
})(["display:flex;gap:0.4rem;"]), l = o.div.withConfig({
  displayName: "HelperText",
  componentId: "sc-8qnsok-1"
})(["-webkit-box-orient:vertical;-webkit-line-clamp:", ";display:-webkit-box;font-size:1.2rem;overflow:hidden;"], ({
  lineClamp: e
}) => e), c = o.div.withConfig({
  displayName: "HelperCounter",
  componentId: "sc-8qnsok-2"
})(["font-size:1.2rem;"]), s = o.div.withConfig({
  displayName: "Helper",
  componentId: "sc-8qnsok-3"
})(["align-items:center;color:var(--color-components-input-fg-default);display:flex;flex-direction:row;justify-content:space-between;padding-top:4px;", " ", " ", ""], ({
  success: e
}) => e && t(["color:var(--color-success-default);"]), ({
  error: e
}) => e && t(["color:var(--color-error-default);"]), ({
  size: e
}) => {
  const n = `var(--size-components-input-height-${e})`;
  return t(["margin-left:calc(", " / 2.5);margin-right:calc(", " / 2.5);"], n, n);
});
export {
  s as Helper,
  r as HelperBody,
  c as HelperCounter,
  l as HelperText
};
//# sourceMappingURL=style.es.js.map
